import DOMPurify from "dompurify";
import React, { useEffect, useState } from "react";


import arrowDown from "./assets/CaretDown.svg";

interface Heading {
    category: string;
    title?: string;
    excerpt?: string;
}

interface Faq {
    question: string;
    answer: string;
}

interface FaqsProps {
    headings: Heading[];
}

const Faqs: React.FC<FaqsProps> = ({ headings }) => {
    const [faqs, setFaqs] = useState<Faq[]>([]);
    const [pageTitle, setPageTitle] = useState("Our FAQs");
    const [pageSubtitle, setPageSubtitle] = useState(
        "Frequently Asked Questions"
    );
    const API_BASE_URL = process.env.REACT_APP_API_USER_BASE_URL;

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const url = new URL(`${API_BASE_URL}/api/v1/user/faqs`);
                const params: Record<string, string> = {
                    type: "",
                };
                Object.entries(params).forEach(([key, value]) => {
                    url.searchParams.append(key, value);
                });

                const headers = {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                };

                const response = await fetch(url.toString(), {
                    method: "GET",
                    headers,
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                setFaqs(data.data);
            } catch (error) {
                console.error("Error fetching FAQs:", error);
            }
        };

        fetchFaqs();
    }, [API_BASE_URL]);

    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const toggleDropDown = (index: number) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    useEffect(() => {
        const faqsHeading = headings.find((heading) => heading.category === "Faqs");
        if (faqsHeading) {
            setPageTitle(faqsHeading.title || "Our FAQs");
            setPageSubtitle(faqsHeading.excerpt || "Frequently Asked Questions");
        }
    }, [headings]);

    return (
        <>
            <div className="flex items-center flex-col py-16 mt-16 w-full px-4 md:px-14">
                <h3 className="text-center">{pageTitle}</h3>
                <h2 className="text-center mt-3">{pageSubtitle}</h2>

                <div className="mt-16 w-full">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            onClick={() => toggleDropDown(index)}
                            className={`border-y py-6 w-full faq border-[#F3F0E933] cursor-pointer${openIndex === index ? " active" : ""
                                }`}
                        >
                            <div className="flex flex-row w-full justify-between items-center">
                                <p className="font-Manrope text-[#000000] text-base md:text-lg font-normal">
                                    {faq.question}
                                </p>
                                <img
                                    src={arrowDown}
                                    className={`${openIndex === index ? "transform rotate-180" : ""
                                        } transition-transform duration-300`}
                                    alt=""
                                />
                            </div>
                            <div className={`answer ${openIndex === index ? "open" : "hidden"}`}>
                                <p
                                    className="font-Manrope text-[#282D2D] font-normal text-sm md:text-base mt-5 transition-all duration-500"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(faq.answer),
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Faqs;
